import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Opens the Willy AI chat from anywhere in the app (e.g. "Diagnose this plant"
 * on the plant details page), optionally pre-filling the message input.
 * The app menu listens to open the modal; the chatbot listens for the prefill.
 */
@Injectable({ providedIn: 'root' })
export class WillyChatService {
  private readonly openChatSubject = new Subject<string | undefined>();
  openChat$ = this.openChatSubject.asObservable();

  /**
   * Ouverture en attente quand le chat est demandé depuis un écran qui n'héberge
   * PAS le menu (ex. le détail d'une plante, dans GardenModule). On mémorise le
   * pré-remplissage ; le menu le consomme une fois monté après la navigation.
   */
  private pendingPrefill: string | null = null;

  /** Ouvre le chat immédiatement (écran qui héberge déjà le menu / le chat). */
  openChat(prefillText?: string) {
    this.openChatSubject.next(prefillText);
  }

  /** Demande une ouverture après navigation : mémorise le pré-remplissage. */
  queueOpenChat(prefillText?: string) {
    this.pendingPrefill = prefillText ?? '';
  }

  /** Récupère et efface la demande d'ouverture en attente (null si aucune). */
  takePendingOpen(): string | null {
    const pending = this.pendingPrefill;
    this.pendingPrefill = null;
    return pending;
  }
}
